export default "__VITE_ASSET__77f13919__"